"use client";

import { useEffect } from "react";
import Image from "next/image";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="w-full px-1 py-4 md:px-0 md:py-2 md:mt-4 text-center">
      <div className="w-3/4 m-auto py-[40px] md:py-[160px]">
        <div className="flex flex-col items-center">
          <Image
            alt="404 Not Found"
            src="/404-not-found.webp"
            className="max-w-[300px] w-full"
            placeholder="blur"
            blurDataURL="/404-not-found-blur.webp"
            sizes="100vw"
            width={0}
            height={0}
            style={{ maxWidth: "300px", width: "auto", height: "auto" }}
          />
        </div>
        <h2 className="text-xl">
          We apologize! Something went wrong on our side.
        </h2>
        <p>
          We couldn't load the content you're looking for. Please try again
          later.
        </p>
        <button
          className="text-white bg-getjar-darkorange hover:bg-getjar-orange focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          onClick={() => reset()}
          title="refresh"
          aria-label="Refresh the page"
        >
          Refresh the page
        </button>
      </div>
    </div>
  );
}
